import i18next from "i18next";
import {
  encryptObject,
  getLocalStorageItem,
  setLocalStorageItem,
  setSessionStorageItem,
  getUserPayload,
} from "../../system";
import {
  StorageKeys,
  loginConstants,
  viewPathConstants,
  translationConstants,
  globalSystemConstants,
  registrationConstants,
  profileConstants,
  serverResponseConstants,
  centersConstants,
} from "../../constants";
import { UserActions } from "./user.actions";
import { instructorActions } from "./instructor.action";
import { success, failure, custom } from "./utilities";
import { ToastifyService, authService } from "../../services";
import { profileActions } from "./profile.action";

export const emailVerification = (
  queryParam,
  navigate,
  setShowForgotPasswordModal
) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );
    authService
      .verifyEmail(queryParam)
      .then((response) => {
        dispatch(success(response, loginConstants.EMAIL_VERIFIED));

        if (response === "forgot_password_request_processed") {
          const message = i18next.t(translationConstants.verificationLinkSent);
          ToastifyService.showSuccess(message);
          if (setShowForgotPasswordModal) {
            setShowForgotPasswordModal(false);
          } else {
            navigate(viewPathConstants.DEFAULT_PATH);
          }
        } else {
          ToastifyService.showError(i18next.t(response));
        }
      })
      .catch((error) => {
        ToastifyService.showError(error.join(""));
        dispatch(failure(error.join(""), loginConstants.EMAIL_VERIFIED));
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

export const login = (queryParam, onSuccess) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );
    authService
      .login(queryParam)
      .then((response) => {
        dispatch(success(response, loginConstants.LOGIN));
        ToastifyService.showSuccess(translationConstants.SUCCESSFULLY_LOGIN);

        setLocalStorageItem(
          process.env.REACT_APP_PAYLOAD,
          encryptObject(response)
        );
        setLocalStorageItem(StorageKeys.Token, { token: response?.token });
        setLocalStorageItem(StorageKeys.Role, {
          token: response?.user?.role,
        });
        setLocalStorageItem(
          StorageKeys.userVerificationDocumentStatus,
          response?.user?.userStatus
        );
        setLocalStorageItem(
          StorageKeys.userSportDocumentStatus,
          response?.practionerStatus
        );
        setLocalStorageItem(
          StorageKeys.instructorStatus,
          response?.instructorStatus
        );
        setLocalStorageItem(StorageKeys.activeRole, response?.user?.role);
        setLocalStorageItem(
          StorageKeys.instructorInvitedCenterName,
          response?.instructorInvitedCenterName
        );
        dispatch(setActiveProfile(response?.user?.role));
        setLocalStorageItem(
          StorageKeys.KeepMeSignedIn,
          queryParam.keepMeSignedIn ? true : false
        );
        if (onSuccess) {
          onSuccess();
        }
      })
      .catch((error) => {
        // Dispatch a failure action in case of an error
        const message = i18next.t(error);
        ToastifyService.showError(message);
        dispatch(failure(error, loginConstants.LOGIN));
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

export const getNewUserPayload = (onSuccess) => {
  return (dispatch) => {
    const oldpayload = getUserPayload();
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );
    authService
      .getNewUserPayload(oldpayload?.token)
      .then((response) => {
        setLocalStorageItem(
          process.env.REACT_APP_PAYLOAD,
          encryptObject(response)
        );
        setLocalStorageItem(StorageKeys.Token, { token: response?.token });
        setLocalStorageItem(StorageKeys.Role, {
          token: response?.user?.role,
        });
        setLocalStorageItem(
          StorageKeys.userVerificationDocumentStatus,
          response?.user?.userStatus
        );
        setLocalStorageItem(
          StorageKeys.userSportDocumentStatus,
          response?.practionerStatus
        );
        setLocalStorageItem(
          StorageKeys.instructorStatus,
          response?.instructorStatus
        );
        setLocalStorageItem(StorageKeys.activeRole, response?.user?.role);
        setLocalStorageItem(
          StorageKeys.instructorInvitedCenterName,
          response?.instructorInvitedCenterName
        );
        dispatch(setActiveProfile(response?.user?.role));
      })
      .catch((error) => {
        // Dispatch a failure action in case of an error
        const message = i18next.t(error);
        ToastifyService.showError(message);
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
        if (onSuccess) {
          onSuccess();
        }
      });
  };
};

export const resetPassword = (resetData, navigate) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );

    authService
      .resetPassword(resetData)
      .then((response) => {
        dispatch(success(response, loginConstants.PASSWORD_RESET_SUCCESS));
        // Show success message
        const message = i18next.t(translationConstants.passwordChanged);
        navigate(viewPathConstants.DEFAULT_PATH);

        ToastifyService.showSuccess(message);
      })
      .catch((error) => {
        const message = i18next.t(translationConstants.password_changed);
        ToastifyService.showError(message);
        dispatch(failure(error, loginConstants.PASSWORD_RESET_FAILURE));
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

export const registerUser = (
  registrationData,
  navigate,
  handleShowRegSuccessModal
) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );

    authService
      .registerUser(registrationData)
      .then((response) => {
        const userDetail = { status: 4, tokenExpired: false };
        dispatch(
          success(userDetail, registrationConstants.REGISTRATION_SUCCESS)
        );
        if (handleShowRegSuccessModal) {
          handleShowRegSuccessModal();
        } else {
          navigate(viewPathConstants.REGISTRATION_SUCCESS);
        }
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

export const becomeVerifiedUser = (UserVerfiedDocs, navigate) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );

    authService
      .becomeVerifiedUser(UserVerfiedDocs)
      .then((response) => {
        if (response) {
          dispatch(success(3, loginConstants.UNDER_REVIEW));
          if (getLocalStorageItem(StorageKeys.userVerificationDocumentStatus)) {
            setLocalStorageItem(StorageKeys.userVerificationDocumentStatus, 3);
          } else {
            setLocalStorageItem(StorageKeys.userVerificationDocumentStatus, 3);
          }
          dispatch(UserActions.OpenModal(false));
          const status = { userStatus: 10, message: "documents_submitted" };
          dispatch(success(status, registrationConstants.REGISTRATION_STATUS));
          navigate(viewPathConstants.NOTIFICATION);
        }
      })
      .catch((error) => {
        ToastifyService.showError(error);
        dispatch(failure(error.message, loginConstants.VERIFICATION_FAILED));
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

export const fetchCountries = () => {
  return (dispatch) => {
    authService
      .fetchCountries()
      .then((response) => {
        dispatch(
          success(response, registrationConstants.REGISTRATION_COUNTRIES)
        );
      })
      .catch((error) => {
        const message = i18next.t(serverResponseConstants.SOMETHING_WENT_WRONG);
        ToastifyService.showError(message);
      });
  };
};

export const fetchCities = (countryId) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );
    authService
      .fetchCities(countryId)
      .then((response) => {
        dispatch(
          success(response.data, registrationConstants.REGISTRATION_CITIES)
        );
      })
      .catch((error) => {
        const message = i18next.t(translationConstants.citiesNotFetch);
        ToastifyService.showError(message);
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

export const registrationStatus = (userDetail) => {
  return (dispatch) => {
    authService
      .registrationStatus(userDetail)
      .then((response) => {
        dispatch(success(response, registrationConstants.REGISTRATION_STATUS));
      })
      .catch((error) => {
        const status = { userStatus: 4, message: "" };
        dispatch(success(status, registrationConstants.REGISTRATION_STATUS));
      });
  };
};

export const resendEmail = (userId) => {
  return (dispatch) => {
    authService
      .resendEmail(userId)
      .then((response) => ToastifyService.showSuccess(response))
      .catch((error) => ToastifyService.showError(error));
  };
};

export const changePassword = (data, setShow) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );
    authService
      .changePassword(data)
      .then((response) => {
        const message = i18next.t(translationConstants.UPDATED_SUCCESSFULLY);
        if (response) {
          ToastifyService.showSuccess(message);
          setShow(false);
        }
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

const updateUserDocuments = (UserVerfiedDocs) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );

    authService
      .updateUserDocuments(UserVerfiedDocs)
      .then((message) => {
        if (message) {
          ToastifyService.showSuccess(message);
          dispatch(instructorActions.toggleViewModal(false));
          dispatch(instructorActions.toggleViewModal(false));
          dispatch(profileActions.getProfileData(UserVerfiedDocs.systemUserId));
        }
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

const setActiveProfile = (data) => {
  return (dispatch) => {
    dispatch(custom(data, profileConstants.GET_ACTIVE_PROFILE));
  };
};
const setLoginFromRegistration = (data) => {
  return (dispatch) => {
    dispatch(custom(data, loginConstants.ISLOGIN_FROM_COMPT_REG_FORM));
  };
};

const setCenterStatusInLoginReducer = (status) => {
  return (dispatch) => {
    const newData = getUserPayload();

    setLocalStorageItem(
      process.env.REACT_APP_PAYLOAD,
      encryptObject({ ...newData, centerStatus: status })
    );
    dispatch(
      custom(status, centersConstants.SET_CENTER_STATUS_IN_LOGIN_REDUCER)
    );
  };
};

const setIsMemberStatusInLoginReducer = (status) => {
  return (dispatch) => {
    const newData = getUserPayload();

    setLocalStorageItem(
      process.env.REACT_APP_PAYLOAD,
      encryptObject({
        ...newData,
        user: { ...newData.user, isMembershipHolder: status },
      })
    );
    dispatch(
      custom(status, centersConstants.SET_ISMEMBER_STATUS_IN_LOGIN_REDUCER)
    );
  };
};

const setIsFreelancerStatusInLoginReducer = (status) => {
  return (dispatch) => {
    const newData = getUserPayload();

    setLocalStorageItem(
      process.env.REACT_APP_PAYLOAD,
      encryptObject({
        ...newData,
        user: { ...newData.user, role: status },
      })
    );

    dispatch(
      custom(status, centersConstants.SET_ISFREELANCER_STATUS_IN_LOGIN_REDUCER)
    );
  };
};
const setShowLoginModal = (data) => {
  return (dispatch) => {
    dispatch(custom(data, loginConstants.SHOW_LOGIN_MODAL));
  };
};
export const logout = () => {
  return (dispatch) => {
    dispatch(custom(null, loginConstants.LOGOUT));
  };
};
export const authActions = {
  emailVerification,
  login,
  resetPassword,
  registerUser,
  becomeVerifiedUser,
  fetchCountries,
  fetchCities,
  registrationStatus,
  resendEmail,
  changePassword,
  updateUserDocuments,
  setActiveProfile,
  setLoginFromRegistration,
  setCenterStatusInLoginReducer,
  setIsMemberStatusInLoginReducer,
  setIsFreelancerStatusInLoginReducer,
  setShowLoginModal,
  getNewUserPayload,
};
